<template>
  <div class="certificate-profile">
    <Header ></Header>
    <sub-header :title="'صفحة الرخصة'"></sub-header>

    <div class="certificate-info">
      <b-container>
        <div class="tab-container mb-4">
          <b-row>
            <b-col md="4" cols="12">
              <div class="certificate-picture">
                <img
                  v-if="certificateData.file"
                  :src="certificateData.file.url"
                  alt=""
                />
              </div>
            </b-col>
            <b-col md="8" cols="12">
              <CertificateDescription
                :certificateData="certificateData"
              ></CertificateDescription>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col md="12" cols="12">
            <div class="row ">
      <div class="sec-wrapper d-flex align-items-center mb-4">
        <h2 id="famous-companies " class="section-title"
        >
        التدريبات للحصول على الرخصة</h2>
        <div class="blue-line"></div>
      </div>
      <div
        v-for="company in certificateData.training_programs"
        :key="company.id"
        class="col-md-3 col-12 mb-30"
      >
        <div class="mfbox ">
          <div class="mfbox__image">
            <img v-if="company.image" :src="company.image.url" />
          </div>
        </div>
      </div>
    </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" cols="12">
            <div class="row ">
      <div class="sec-wrapper d-flex align-items-center mb-4">
        <h2 id="famous-companies " class="section-title"
        >
        الجهات المقدمة للتدريب </h2>
        <div class="blue-line"></div>
      </div>
      <div
        v-for="company in certificateData.training_companies"
        :key="company.id"
        class="col-md-3 col-12 mb-30"
      >
        <div class="mfbox ">
          <div class="mfbox__image">
            <router-link :to="`/training-company/${company.id}`">

            <img v-if="company.image" :src="company.image.url" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import CertificateDescription from "@/components/Certificate/CertificateDescription.vue";
import Header from "@/components/Certificate/Header.vue";
import Footer from "@/components/Home/Footer.vue";
import axios from "axios";
import SubHeader from '@/components/Certificate/SubHeader.vue';

export default {
  name: "certificateShow",
  components: { Header, Footer , CertificateDescription ,SubHeader },
  data() {
    return {
      tabIndex: 0,
      certificateData: {},
      searchQuery: null,
    };
  },
  async created() {
    // Fetch data from APIs
    await this.fetchcertificateData();

  },
  watch: {
    searchQuery: {
      immediate: true,
    },
  },



  methods: {
    async fetchcertificateData() {
      try {
          const response = await axios.get(
          `/licenses/${this.$route.params.id}`
        );
        this.certificateData = response.data.data.license;

      } catch (error) {
        console.error("Error fetching certificate data:", error);
      }
    },


  },
};
</script>
<style lang="">
</style>
